import { render } from "./CommunicationsView.vue?vue&type=template&id=16eb8678&ts=true"
import script from "./CommunicationsView.vue?vue&type=script&lang=ts"
export * from "./CommunicationsView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__